export const ContentBankTabsEnum = {
    myMaterials: 1,
    sharedMaterials: 2,
    headquartersRepository: 3,
    nationalRepository: 4,
    favorites: 5,
    recentUses: 6
}